var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarlyMorning = function SvgEarlyMorning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "earlyMorning_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#earlyMorning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M19.339 7.711a.5.5 0 0 1 .16.354.5.5 0 0 1-.16.354l-1.014 1.013a.5.5 0 0 1-.347.156.47.47 0 0 1-.367-.156.49.49 0 0 1-.162-.357.5.5 0 0 1 .168-.356l1.014-1.014a.5.5 0 0 1 .347-.147.47.47 0 0 1 .36.153M3 19.5a.48.48 0 0 1-.357-.144A.48.48 0 0 1 2.5 19q0-.215.143-.357A.48.48 0 0 1 3 18.5h18q.213 0 .357.143A.48.48 0 0 1 21.5 19a.48.48 0 0 1-.143.356.48.48 0 0 1-.357.144zm9-14.654q.213 0 .357.143a.48.48 0 0 1 .143.357V6.73a.48.48 0 0 1-.143.357.48.48 0 0 1-.357.143.48.48 0 0 1-.357-.143.48.48 0 0 1-.143-.357V5.346q0-.214.143-.357A.48.48 0 0 1 12 4.846M4.673 7.7a.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16l1.013 1.013a.5.5 0 0 1 .156.347.47.47 0 0 1-.156.366.5.5 0 0 1-.36.16.48.48 0 0 1-.353-.165L4.667 8.407a.5.5 0 0 1-.147-.347.47.47 0 0 1 .153-.36M7.425 14h9.15a4.85 4.85 0 0 0-1.81-2.175A4.87 4.87 0 0 0 12 11q-1.53 0-2.765.825A4.85 4.85 0 0 0 7.425 14m-1.31 1q.346-2.175 2.009-3.588T12 10t3.876 1.412T17.885 15z"
  }))));
};
export default SvgEarlyMorning;